import React from 'react'
import Button from '@blocks/Button'

export interface AddProps {
    handle(): void
}

const Add = ({ handle }: AddProps) => {
    return <Button onClick={handle}>Add</Button>
}

export default React.memo(Add)